module.exports = __webpack_public_path__ + "static/media/NotCalled.e11aeee6.png";